import { render, staticRenderFns } from "./PartnerVerticalNavMenu.vue?vue&type=template&id=4080d565"
import script from "./PartnerVerticalNavMenu.vue?vue&type=script&lang=js"
export * from "./PartnerVerticalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./PartnerVerticalNavMenu.vue?vue&type=style&index=0&id=4080d565&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports